import { useEffect, useRef, useState } from "react";

export const useScrollEdges = <T extends HTMLElement>() => {
	const ref = useRef<T>(null);
	const [isScrollAtTop, setIsScrollAtTop] = useState(false);
	const [isScrollAtBottom, setIsScrollAtBottom] = useState(false);

	useEffect(() => {
		const el = ref.current;
		if (!el) {
			return;
		}

		const update = () => {
			setIsScrollAtTop(el.scrollTop <= 0);
			setIsScrollAtBottom(
				el.scrollTop + el.clientHeight >= el.scrollHeight - 1,
			);
		};

		update();
		el.addEventListener("scroll", update);

		const resizeObserver = new ResizeObserver(update);
		resizeObserver.observe(el);

		return () => {
			el.removeEventListener("scroll", update);
			resizeObserver.disconnect();
		};
	}, []);

	return { ref, isScrollAtTop, isScrollAtBottom };
};
